module.exports = __webpack_public_path__ + "img/feiyong.1bba7737.png";